import { Routes } from '@angular/router';
import { ArticleComponent } from '@app/article/article.component';
import { DeviceLoginComponent } from '@app/device-login/device-login.component';
import { PageNotFoundComponent } from '@app/page-not-found/page-not-found.component';
import { ProfileComponent } from '@app/profile/profile.component';
import { ChatComponent } from './chat/chat.component';
import { ModalPageComponent } from './components/modal/modal-page.component';
import { LoginComponent } from './login/login.component';
import { LogoutPageComponent } from './logout/logout.component';
import { adminGuard } from './services/admin.guard';
import { authGuard } from './services/auth.guard';
import { maintenanceGuard } from './services/maintenance.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [maintenanceGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'logout',
        component: LogoutPageComponent,
      },
      {
        path: '',
        redirectTo: 'chat/empty',
        pathMatch: 'full',
      },
      {
        path: 'chat',
        redirectTo: 'chat/empty',
        pathMatch: 'full',
      },
      {
        path: 'chat/:tabId',
        component: ChatComponent,
        canActivate: [authGuard],
        data: { checkQueryParams: true },
      },
      {
        path: 'article/:provider/:category',
        component: ArticleComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile',
        redirectTo: 'profile/me',
        pathMatch: 'full',
      },
      {
        path: 'profile/:username',
        component: ModalPageComponent,
        canActivate: [authGuard],
        data: {
          component: ProfileComponent,
          autoFocus: '__any_element_within_dialog__',
          dialogData: {
            // additional data to pass to the dialog
          },
        },
      },
      {
        path: 'devices',
        component: ModalPageComponent,
        canActivate: [authGuard, adminGuard],
        data: {
          component: DeviceLoginComponent,
          autoFocus: '__any_element_within_dialog__',
          dialogData: {
            // additional data to pass to the dialog
          },
        },
      },
      {
        path: 'documents',
        component: ModalPageComponent,
        canActivate: [authGuard],
        data: {
          component: ArticleComponent,
          autoFocus: '__any_element_within_dialog__',
          dialogData: {
            // additional data to pass to the dialog
            showCloseButton: true,
            showPrintButton: true,
            closeOnEscape: false,
          },
        },
      },
      {
        path: '**',
        component: PageNotFoundComponent,
      },
    ],
  },
];
